export interface PortfolioData {
  isEndorsed?: boolean;
  isApproved?: boolean;
  endorsalRejected?: boolean;
  approvalRejected?: boolean;
  endorsedAt?: string;
  approvedAt?: string;
  endorsalRejectionReason?: string;
  approvalRejectionReason?: string;
  endorsalRejectionComment?: string;
  approvalRejectionComment?: string;
  
  endorsementStatus?: 'pending' | 'endorsed' | 'rejected' | 'skipped';
  approvalStatus?: 'pending' | 'approved' | 'rejected';
  reviewHistory?: any[];
  changeHistory?: any[];
  submissionVersion?: number;
}

export const getEndorsementStatus = (portfolio: PortfolioData | null | undefined): 'pending' | 'endorsed' | 'rejected' | 'skipped' => {
  if (!portfolio) return 'pending';
  
  if (portfolio.endorsementStatus) {
    return portfolio.endorsementStatus;
  }

  if (portfolio.isEndorsed === true) return 'endorsed';
  if (portfolio.endorsalRejected === true) return 'rejected';
  return 'pending';
};

export const getApprovalStatus = (portfolio: PortfolioData | null | undefined): 'pending' | 'approved' | 'rejected' => {
  if (!portfolio) return 'pending';

  if (portfolio.approvalStatus) {
    return portfolio.approvalStatus;
  }
  
  if (portfolio.isApproved === true) return 'approved';
  if (portfolio.approvalRejected === true) return 'rejected';
  return 'pending';
};

export const isEndorsed = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getEndorsementStatus(portfolio);
  return status === 'endorsed';
};

export const isEndorsementCompleted = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getEndorsementStatus(portfolio);
  return status === 'endorsed' || status === 'skipped';
};

export const isEndorsementRejected = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getEndorsementStatus(portfolio);
  return status === 'rejected';
};

export const isApproved = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getApprovalStatus(portfolio);
  return status === 'approved';
};

export const isApprovalRejected = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getApprovalStatus(portfolio);
  return status === 'rejected';
};

export const isPendingEndorsement = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getEndorsementStatus(portfolio);
  return status === 'pending';
};

export const isPendingApproval = (portfolio: PortfolioData | null | undefined): boolean => {
  const status = getApprovalStatus(portfolio);
  return status === 'pending';
};

export const getRejectionReason = (portfolio: PortfolioData | null | undefined): string | undefined => {
  if (!portfolio) return undefined;
  
  if (isEndorsementRejected(portfolio)) {
    return portfolio.endorsalRejectionReason;
  }
  
  if (isApprovalRejected(portfolio)) {
    return portfolio.approvalRejectionReason;
  }
  
  return undefined;
};

export const getRejectionComment = (portfolio: PortfolioData | null | undefined): string | undefined => {
  if (!portfolio) return undefined;
  
  if (isEndorsementRejected(portfolio)) {
    return portfolio.endorsalRejectionComment;
  }
  
  if (isApprovalRejected(portfolio)) {
    return portfolio.approvalRejectionComment;
  }
  
  return undefined;
};

export const getRejectionStage = (portfolio: PortfolioData | null | undefined): 'endorsement' | 'approval' | null => {
  if (!portfolio) return null;
  
  if (isEndorsementRejected(portfolio)) {
    return 'endorsement';
  }
  
  if (isApprovalRejected(portfolio)) {
    return 'approval';
  }
  
  return null;
};


export const titleCase =(str:string)=>{
  if(!str)return;
  return str.slice(0,1).toUpperCase() + str.slice(1); 
}